import React from "react";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import { useState } from "react";
import { fetchUsersPut } from "../../services/api-raindrop.js";

import RaindropInput from "../raindrop-input/raindrop-input.tsx";

import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentUserPII = ({
  userPIIId,
  userId,
  nameLegal = "John Smith",
  namePreferred = "John",
  userEmail = "rh@sfrkjh.com",
  isEditable = true,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newNameLegal, setNewNameLegal] = useState(nameLegal);
  const [newNamePreferred, setNewNamePreferred] = useState(namePreferred);
  const [newUserEmail, setNewUserEmail] = useState(userEmail);

  const onCancel = () => {
    setIsEditing(false);
    setNewNameLegal(nameLegal);
    setNewNamePreferred(namePreferred);
    setNewUserEmail(userEmail);
  };

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchUsersPut({
      userId: userId,
      namePreferred: newNamePreferred,
      nameLegal: newNameLegal,
      userEmail: newUserEmail,
    })
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsEditing(false);
        setIsSubmitting(false);
      });
  };

  return (
    <ModelComponent
      modelId={userPIIId}
      colorBorderAccent="border-color-model-user-pii dark:border-color-dark-model-user-pii"
    >
      <RaindropInput
        label={"Full Legal Name"}
        value={newNameLegal}
        onChange={(e) => setNewNameLegal(e.target.value)}
        icon={null}
        isEditing={isEditing}
        isShowLabel={true}
      />
      <RaindropInput
        label={"Preferred Name"}
        value={newNamePreferred}
        onChange={(e) => setNewNamePreferred(e.target.value)}
        icon={null}
        isEditing={isEditing}
        isShowLabel={true}
      />
      <RaindropInput
        label={"Email"}
        value={newUserEmail}
        onChange={(e) => setNewUserEmail(e.target.value)}
        icon={null}
        isEditing={isEditing}
        isShowLabel={true}
      />

      {isEditable && (
        <div className="flex flex-row w-full justify-start">
          {!isEditing && (
            <RaindropButton
              onClick={() => setIsEditing(true)}
              style={ButtonStyle.Secondary}
              title={"Edit"}
              icon="fa-edit"
            />
          )}
          {isEditing && (
            <>
              <RaindropButton
                onClick={onCancel}
                style={ButtonStyle.Secondary}
                title={"Cancel"}
                icon="fa-cancel"
              />
              <RaindropButton
                title={"Save"}
                icon={"fa-save"}
                onClick={onSubmit}
                isLoading={isSubmitting}
              />
            </>
          )}
        </div>
      )}
    </ModelComponent>
  );
};

export default ModelComponentUserPII;
